// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { getLanguageById, editLanguage } from "../../../features/language"; // Adjust the path as necessary
import { isoLanguages } from "../../../assets/language";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";

const EditLanguage = () => {
  const { id } = useParams<{ id: string }>();
  const { language, status } = useSelector((state: any) => state.language); // Adjust state as necessary
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    folder_name: "language",
    language_code: "",
    language: "",
    contant: null,
  });

  useEffect(() => {
    // Fetch language data by ID
    dispatch(getLanguageById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && language) {
      const data = language.data;
      setFormData({
        folder_name: data.folder_name,
        language_code: data.language_code,
        language: data.language,
        contant: data.contant,
      });
    }
  }, [status, language]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>, field: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        contant: e.target.files[0], 
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(editLanguage({ id, updatedLanguage: formDataFinal }))
      .then((res: any) => {
        toast.success(res.payload.message);
        navigate("/languages"); 
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the language.");
      });
  };
console.log(formData,'formData');

  return (
    <SoftBox
      className="language-box"
    >
                  <DashboardNavbar />
      
      <SoftBox >
        <SoftBox mb={1}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Language
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={1}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Language
              </SoftTypography>
            </SoftBox>
            <input
              name="language"
              value={formData.language}
              disabled
              onChange={(e) => handleSelectChange(e, "language")}
              className="file-type-input"
              />
              {/* <option value="">Select a language</option>
              {isoLanguages.map((lang) => (
                <option key={lang.code} value={lang.name}>
                  {lang.name}
                </option>
              ))}
            </select> */}
          </SoftBox>

       

          <SoftBox mb={2}>
            <SoftBox  ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Content (Excel file)
              </SoftTypography>
            </SoftBox>
            {formData.contant && (
              <SoftTypography variant="body2"  color="textSecondary">
                {formData.contant.name}
              </SoftTypography>
            )}
            <input
              type="file"
              name="contant"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-type-input"
            />
          </SoftBox>

          <SoftBox mt={2} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditLanguage;
